import { createReducer, on } from '@ngrx/store';

import {
  resetRadiusOverride,
  updateRadiusOverride,
} from './radius-override.actions';

export const initialState = false;

export const radiusOverrideReducer = createReducer(
  initialState,
  on(updateRadiusOverride, (state, { overrideRadius }) => overrideRadius),
  on(resetRadiusOverride, () => initialState)
);
